import { Component, OnInit, ElementRef, ViewChild } from '@angular/core';
import { BillingLetter } from '../../../models/billing-letter/BillingLetter.model';
import { BillingLetterService } from '../../../services/billing-letter/billing-letter.service';
import { BillingParcelService } from '../../../services/billing-letter/billing-parcel.service';
import { Owner } from "../../../models/billing-letter/Owner.model";
import { Company } from "../../../models/billing-letter/Company.model";
import { OwnerService } from "../../../services/billing-letter/owner.service";
import { NatureProvider } from "../../../shared/providers/enums/nature.provider";
import { ValueClassProvider } from "../../../shared/providers/enums/value-class.provider";
import { CompetenceProvider } from "../../../shared/providers/enums/billing-letter/competence-provider";
import { AccountingPeriodBlock } from "../../../models/AccountingPeriodBlock.model";
import { AccountingPeriodBlockService } from "../../../services/accountingBlock.service";
import { Parcel } from "../../../models/billing-letter/Parcel.model";
import { CommonHelper } from "../../../shared/helpers/CommonHelper";
import { Contact } from "../../../models/billing-letter/Contact.model";
import { ProjectFinancialService } from '../../../services/projectFinancial.service';
import { ProductService } from '../../../services/product.service';
import { RefundsService } from '../../../services/refund.service';
import { CnaeService } from '../../../services/cnae.service';
import { ToastsManager } from 'ng2-toastr';
import { StatusProvider } from "../../../shared/providers/enums/billing-letter/status-provider";
import * as moment from 'moment';
import * as _ from 'lodash';
import { CompanyService } from '../../../services/billing-letter/company.service';
import { ProjectFinancial } from '../../../models/project/ProjectFinancial.model';
import { DropdownItemFactory } from '../../../shared/factories/dropdown/dropdown-item.factory';
import { DropdownSettingsFactory } from '../../../shared/factories/dropdown/dropdown-settings.factory';
import { CompanyGroup } from "../../../models/billing-letter/CompanyGroup.model";
import { Product } from "../../../models/billing-letter/Product.model";
import { ProductFinancial } from '../../../models/project/ProductFinancial.model';
import { RefundBilling } from '../../../models/billing-letter/Refund.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import { ErrorHandlerProvider } from '../../../shared/providers/errorHandler.provider';
import { AutoIncrement } from "../../../shared/helpers/auto-increment";
import { Router } from '@angular/router';
import { AccountingType } from '../../../shared/enums/AccountingBlockType';
import { ProductType } from '../../../shared/enums/billing-letter/productType';

@Component({
    selector: 'app-billing-letter-create',
    templateUrl: './billing-letter-create.component.html',
    styleUrls: ['./billing-letter-create.component.scss']
})
export class BillingLetterCreateComponent implements OnInit {
    @ViewChild("buttonclosemodal") buttonclosemodal: ElementRef;
    @ViewChild("buttonOpenModalParcel") buttonOpenModalParcel: ElementRef;

    users: Owner[] = [];
    companies: Company[] = [];
    companyGroups: CompanyGroup[] = [];
    projects: ProjectFinancial[];
    products: Product[];
    contractTypes: any[] = [];
    productType: number = 0;
    refunds: RefundBilling[];
    projectsByCompany;
    projectsByGroup;
    selectedCompany: String;
    nextParcelConfiguration: Parcel;
    recurrence = 1;
    isRecurrence: boolean = false;
    datePickerOptions = this.commonHelper.getDatePickerOptions();
    competenceYear = this.commonHelper.listLastYears();
    valueClasses = this.valueClassProvider.valueClasses;
    statuses = this.statusesProvider.statuses;
    natures = this.natureProvider.natures;
    competencesParcel = this.competenceProvider.competences;
    parcelIndexAddRefund: number = -1;
    refundsToUpdate = [];

    joinParcels: Array<{ name: string, parcels: Array<any> }> = []
    joinParcelsDropdown = {
        list: [],
        options: null,
        selected: []
    };

    projectsDropdown = {
        list: [],
        options: null,
        selected: []
    };
    productsDropdown = {
        list: [],
        options: null,
        selected: []
    };
    companiesDropdown = {
        list: [],
        options: null,
        selected: []
    }
    refundsDropdown = {
        list: [],
        options: null,
        selected: []
    };
    cnaes;
    companyAux = { id: '', itemName: '' };

    billingLetter: BillingLetter = new BillingLetter();
    currentStep = 'basic';
    eaParcels = false
    multiParcels = false

    onlyCompetence: number = 0;
    loading;
    months = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    valuesProject;
    valuesProduct;

    indexParcelModal: number;

    objParcelModal: any;
    isCreate: boolean = false;
    modalOpen: boolean = false;
    accountingBlock = new AccountingPeriodBlock();

    constructor(private billingLetterService: BillingLetterService,
        private billingParcelService: BillingParcelService,
        private projectFinancialService: ProjectFinancialService,
        private productService: ProductService,
        private ownerService: OwnerService,
        private valueClassProvider: ValueClassProvider,
        private statusesProvider: StatusProvider,
        private natureProvider: NatureProvider,
        private competenceProvider: CompetenceProvider,
        private commonHelper: CommonHelper,
        private toastr: ToastsManager,
        private companyService: CompanyService,
        private dropDownItemFactory: DropdownItemFactory,
        private dropDownSettingFactory: DropdownSettingsFactory,
        private refundService: RefundsService,
        private cnaeService: CnaeService,
        private errorHandler: ErrorHandlerProvider,
        private accountingBlockService: AccountingPeriodBlockService,
        private router: Router,
        private newContractTypeEnum: ProductType) { }

    async ngOnInit() {
        this.loading = true;
        this.accountingBlock = (await this.accountingBlockService.getAllBlockedPeriods())
            .find(({type}: AccountingPeriodBlock) => type === AccountingType.BillingLetter);

        // this.populateContractTypes();

        this.loadNextParcel();
        this.projectsDropdown.options = this.dropDownSettingFactory.build({ text: 'Projetos' });
        this.productsDropdown.options = this.dropDownSettingFactory.build({ text: 'Produtos' });
        this.companiesDropdown.options = this.dropDownSettingFactory.build({ text: 'Clientes' });
        this.refundsDropdown.options = this.dropDownSettingFactory.build({ text: 'Reembolsos', singleSelection: true });
        this.joinParcelsDropdown.options = this.dropDownSettingFactory.build({ text: 'Junção de Parcelas' });

        this.users = await this.ownerService.getActiveUsers();
        this.cnaes = await this.cnaeService.getAllItems([SapItemType.CnaeBilling]);

        this.companyGroups = await this.companyService.getAllCompanyGroups();
        this.companyGroups = _.orderBy(this.companyGroups, [companyGroup => companyGroup.name.toUpperCase()]);
        // this.products = await this.productService.getAllProducts();
        // this.products = _.orderBy(this.products, [product => product.name.toUpperCase()]);
        this.projectsDropdown.list = this.dropDownItemFactory.build({ source: this.projects });
        this.productsDropdown.list = this.dropDownItemFactory.build({ source: this.products });

        if(this.accountingBlock && this.accountingBlock.competenceYear &&
           this.accountingBlock.competence) {
            this.datePickerOptions.minDate = new Date(this.accountingBlock.competenceYear,this.accountingBlock.competence,1);
        }
        this.loading = false;
    }
    populateContractTypes() {
        this.contractTypes = [...this.newContractTypeEnum.contractTypes];
    }

    generateRange(n: number) {
        return Array.from({ length: n }, (_, i) => i + 1);
    }

    async onChangeCompany() {
        this.selectedCompany = this.billingLetter.company._id;
    }

    async save() {
        try {
            let totalBlocking = null;
            if(this.accountingBlock !== null) {
                totalBlocking = Number(this.accountingBlock.competenceYear) + (Number(this.accountingBlock.competence) / 100);
            }

            if(!this.parcelJoinValid()) {
                this.toastr.warning('Uma junção deve possuir um nome e parcelas associadas', 'Junção de Parcela inválida', {
                    toastLife: 8000,
                    showCloseButton: true
                });
                return;
            }

            let projects = this.projectsDropdown.selected.map(project => {
                return <ProjectFinancial>{ _id: project.id, name: project.itemName, sapProjectId: project.sapProjectId }
            });
            let products = this.productsDropdown.selected.map(product => {
                return <ProductFinancial>{ _id: product.id, name: product.itemName, sapItemCode: product.sapItemCode }
            });

            this.billingLetter.projects = projects;
            this.billingLetter.products = products;

            this.loading = true;
            let response = await this.billingLetterService.create(this.billingLetter);
            if (response._id) {

                /* Condition for update refund with billingLetterId */
                if (this.refundsToUpdate.length > 0) {
                    for (let refundsUpdate of this.refundsToUpdate) {
                        refundsUpdate.updateBillingLetterId = true;
                        refundsUpdate.billingLetterId = response._id;
                        let respRefund = await this.refundService.update(refundsUpdate);
                    }
                }

                if (this.billingLetter.parcels.length > 0) {
                    for (let parcel of this.billingLetter.parcels) {
                        parcel.billingLetterId = response._id;
                        parcel['U_NEO_Agrupador'] = this.billingLetter.name;
                    }
                    let parcelsSucess = 0, parcelsError = 0;
                    let responsesParcels = await this.billingParcelService.createMultipleParcels(this.billingLetter.parcels);

                    if (responsesParcels && responsesParcels.length > 0) {
                        for (let parcel of responsesParcels) {
                            if (parcel && parcel._id)
                                parcelsSucess++;
                            else
                                parcelsError++;
                        }

                        if(parcelsSucess && !parcelsError)
                            this.toastr.success(`${parcelsSucess} parcela(s) criada(s) com sucesso`, 'Operação finalizada', {
                                toastLife: 5000,
                                showCloseButton: true
                            });
                        else if(!parcelsSucess && parcelsError)
                            this.toastr.warning(`Erro ao criar ${parcelsError} parcela(s)`, 'Operação finalizada', {
                                toastLife: 5000,
                                showCloseButton: true
                            });
                        else {
                            this.toastr.success(`${parcelsSucess} parcela(s) criada(s) com sucesso`, 'Operação finalizada', {
                                toastLife: 5000,
                                showCloseButton: true
                            });
                            this.toastr.warning(`Erro ao criar ${parcelsError} parcela(s)`, 'Operação finalizada', {
                                toastLife: 5000,
                                showCloseButton: true
                            });
                        }
                    }
                }

                this.loading = false;
                this.toastr.success('Carta de faturamento criada com sucesso!');
                this.billingLetter = new BillingLetter;
                this.router.navigate(['/billing-letter']);

                this.projectsDropdown.selected = [];
                this.productsDropdown.selected = [];
                this.refundsDropdown.selected = [];
                this.joinParcels = [];
            } else {
                this.loading = false;
                this.errorHandler.interceptError(response,'Carta de Faturamento')
            }
        } catch (err) {
            this.loading = false;
            this.errorHandler.interceptError(err, 'Carta de Faturamento')
        }
    }

    addParcelFromLastOne() {
        this.loadNextParcel();
        this.addParcel(0);
    }

    addParcel(index: number) {
        if (this.multiParcels)
            this.nextParcelConfiguration.status = 1;

        this.billingLetter.parcels.push(this.nextParcelConfiguration);
        this.loadNextParcel(index);
        this.updateJoinParcelDropdown(true);
    }

    loadNextParcel(index?) {
        this.nextParcelConfiguration = this.nextParcel(index)
    }

    calculateValueLiquid(index) {
        const parcel = this.billingLetter.parcels[index];
        let valueLiquid = parcel.value;
        if (!isNaN(parcel.iss)) valueLiquid -= parcel.iss;
        if (!isNaN(parcel.pis)) valueLiquid -= parcel.pis;
        if (!isNaN(parcel.irrf)) valueLiquid -= parcel.irrf;
        if (!isNaN(parcel.cofins)) valueLiquid -= parcel.cofins;
        if (!isNaN(parcel.discountGranted)) valueLiquid -= parcel.discountGranted;
        this.billingLetter.parcels[index].valueLiquid = valueLiquid;
        this.loadNextParcel();
    }

    formatDate(date: Date) {
        return this.eaParcels ? moment(date).format('YYYY-MM-DD') : moment(date).add(1, 'M').format('YYYY-MM-DD')
    }

    nextMonthYear(month: number, year: number) {
        const currentMonth = this.months.indexOf(month)
        if (currentMonth === -1)
            return {
                month: this.months[0],
                year: year + 1
            }

        return {
            month: this.months[currentMonth],
            year: year
        }
    }


    nextParcel(index: number) {
        if (this.billingLetter.parcels.length > 0) {

            this.mergeValues();
            const lastPosition = this.billingLetter.parcels.length - 1

            this.billingLetter.parcels[lastPosition].type = this.multiParcels ? 1 : 0;

            const typeMult = this.billingLetter.parcels.filter(p => p.type !== 0)

            if (index === 1) {
                typeMult[typeMult.length - 1].competence = Number(this.onlyCompetence);
                typeMult[typeMult.length - 1].project = this.projectsDropdown.selected.length > 0
                    ? this.projectsDropdown.selected.map(item => ({ _id: item.id, name: item.itemName, value: item.value, sapProjectId: item.sapProjectId }))
                    : [];
                typeMult[typeMult.length - 1].product = this.productsDropdown.selected.length > 0
                    ? this.productsDropdown.selected.map(item => ({ _id: item.id, name: item.itemName, value: item.value, sapItemCode: item.sapItemCode }))
                    : [];
            }

            const lastParcel = this.lastParcel();
            const nextMonth = Number(lastParcel.competence) + 1
            const nextYear = Number(lastParcel.competenceYear)
            const monthYear = this.nextMonthYear(nextMonth, nextYear)

            const projects = lastParcel.project.map((project) => ({
                _id:            project._id,
                name:           project.name,
                value:          project.value,
                sapProjectId:   project.sapProjectId
            }));

            const products = lastParcel.product.map((product) => ({
                _id:            product._id,
                name:           product.name,
                value:          product.value,
                sapItemCode:    product.sapItemCode
            }));

            const excellenceCenters = lastParcel.excellenceCenters.map((ec) => ({
                _id:            ec._id,
                name:           ec.name,
                value:          ec.value,
                sapCode:        ec.sapCode,
                percentage:     ec.percentage
            }));

            const supportCenters = lastParcel.supportCenters.map((ec) => ({
                _id:            ec._id,
                name:           ec.name,
                value:          ec.value,
                sapCode:        ec.sapCode,
                percentage:     ec.percentage
            }));

            const industry = this.getIndustry(lastParcel)
            if (industry) {
                industry.percentage = 100
            }


            const nextParcel = new Parcel({
                ...lastParcel,
                issued: false,
                issueDate: this.formatDate(lastParcel.issueDate),
                dueDate: this.formatDate(lastParcel.dueDate),
                paymentDate: this.formatDate(lastParcel.paymentDate),
                competence: monthYear.month,
                competenceYear: monthYear.year,
                observation: '',
                nf: '',
                project: lastParcel.project.length > 0 ? projects : [],
                product: lastParcel.product.length > 0 ? products : [],
                excellenceCenters: lastParcel.excellenceCenters.length > 0 ? excellenceCenters : [],
                supportCenters: lastParcel.supportCenters.length > 0 ? supportCenters : [],
                industry: industry || {},
                refund: [],
                canEdit: true,
                parcelJoin: '',
                status: 1,
                company: lastParcel.company
            });

            return nextParcel;
        }
        else {
            return new Parcel({
                canEdit: true,
                project:  this.projectsDropdown.selected.length > 0
                    ? this.projectsDropdown.selected.map(item => ({ _id: item.id, name: item.itemName, value: 0, sapProjectId: item.sapProjectId }))
                    : [],
                product:  this.productsDropdown.selected.length > 0
                    ? this.productsDropdown.selected.map(item => ({ _id: item.id, name: item.itemName, value: 0, sapItemCode: item.sapItemCode }))
                    : [],
            })
        }
    }

    lastParcel() {
        return this.billingLetter.parcels[this.billingLetter.parcels.length - 1];
    }

    removeParcel(index) {
        this.billingLetter.parcels.splice(index, 1);
        this.loadNextParcel();
        this.updateJoinParcelDropdown(false, index);
    }

    addContact() {
        this.billingLetter.contacts.push(new Contact());
    }

    removeContact(index) {
        this.billingLetter.contacts.splice(index, 1);
    }

    validLetter() {
        if (_.isEmpty(this.billingLetter.name)
            || this.billingLetter.owner == null
            || this.billingLetter.companyGroup == null
            || this.billingLetter.parcels.length == 0
            ||
            // (
                this.projectsDropdown.selected.length == 0
                // &&
            //     this.productsDropdown.selected.length == 0)
            // || this.billingLetter.productType == 0)
        )
            return false;
        return true;
    }

    async changeGroup() {
        this.companies = await this.companyService.getCompaniesByGroupId(this.billingLetter.companyGroup._id);
        this.companies = _.orderBy(this.companies, [company => company.name.toUpperCase()]);
        this.companies = _.filter(this.companies, item => item.active == true);
        this.companiesDropdown.list = this.dropDownItemFactory.build({ source: this.companies });

        this.projects = await this.projectFinancialService.getProjectByGroupId(this.billingLetter.companyGroup._id);
        this.projects = _.orderBy(this.projects, [project => project.name.toUpperCase()]);
        this.projectsDropdown.list = this.dropDownItemFactory.build({ source: this.projects });

        this.refunds = await this.refundService.getRefundsByGroupId(this.billingLetter.companyGroup._id);
        this.refunds = this.refunds.filter(refund => !refund.associatedBillingLetter);
        this.refunds = this.refunds.map(refund => {
            refund.value = refund.valuePaidCustomer;
            refund.name = `ID: ${refund._id} / Valor pago pelo cliente: R$ ${refund.valuePaidCustomer} / Data: ${moment(refund.created).format("DD/MM/YYYY")} / Consultor: ${refund.consultant ? refund.consultant.name : ''}`;
            return refund;
        });
        this.refundsDropdown.list = this.dropDownItemFactory.build({ source: this.refunds });

        this.companiesDropdown.selected = [];
        this.projectsDropdown.selected = [];
        this.productsDropdown.selected = [];
        this.refundsDropdown.selected = [];
    }

    changeProject() {
        this.billingLetter.projects = [...this.projectsDropdown.selected]
        this.billingLetter.parcels.forEach(parcel => {
            if (parcel.project.length <= this.projectsDropdown.selected.length) {
                let diff = _.differenceWith(this.projectsDropdown.selected, parcel.project, (a, b) => a.id == b._id)
                parcel.project.push({
                    _id: diff[0].id,
                    name: diff[0].itemName,
                    value: 0,
                    sapProjectId: diff[0].sapProjectId
                })
            }
            else {
                let diff = _.differenceWith(parcel.project, this.projectsDropdown.selected, (a, b) => a._id == b.id)
                _.remove(parcel.project, item => item._id == diff[0]._id)
            }
        })
        this.valuesProject = this.generateRange(this.projectsDropdown.selected.length).fill(0)
    }

    changeProduct() {
        this.billingLetter.products = [...this.productsDropdown.selected]
        this.billingLetter.parcels.forEach(parcel => {
            if (parcel.product.length <= this.productsDropdown.selected.length) {
                let diff = _.differenceWith(this.productsDropdown.selected, parcel.product, (a, b) => a.id == b._id)
                parcel.product.push({
                    _id: diff[0].id,
                    name: diff[0].itemName,
                    value: 0,
                    sapItemCode: diff[0].sapItemCode
                })
            }
            else {
                let diff = _.differenceWith(parcel.product, this.productsDropdown.selected, (a, b) => a._id == b.id)
                _.remove(parcel.product, item => item._id == diff[0]._id)
            }
        })
        this.valuesProduct = this.generateRange(this.productsDropdown.selected.length).fill(0)
    }

    setParcelIndexToAddRefund(i) {
        this.parcelIndexAddRefund = parseInt(i);
    }

    clearAddRefund() {
        this.parcelIndexAddRefund = -1;
    }

    addRefund() {
        const i = this.parcelIndexAddRefund;
        const refundSelected = this.refundsDropdown.selected[0];

        if (i < 0 || !refundSelected) return;

        this.billingLetter.parcels[i].refund.push({
            _id: refundSelected.id,
            name: refundSelected.itemName,
            value: refundSelected.value
        });

        //refunds to update
        this.refundsToUpdate.push({
            _id: refundSelected.id,
            associatedBillingLetter: true,
            billingLetterId: ''
        });

        this.refundsDropdown.list = this.refundsDropdown.list.filter(refund => refund.id !== refundSelected.id);

        this.refundsDropdown.selected = [];
        this.clearAddRefund();
        this.buttonclosemodal.nativeElement.click();
        this.modalOpen = true;
    }

    removeRefund(parcelIndex, refundId) {
        let refundListAux = this.billingLetter.parcels[parcelIndex].refund;
        let refundAux = refundListAux.find(refund => refund._id === refundId);
        refundListAux = refundListAux.filter(refund => refund._id !== refundId);

        this.billingLetter.parcels[parcelIndex].refund = refundListAux;
        this.refundsDropdown.list.push({
            id: refundAux._id,
            itemName: refundAux.name,
            value: refundAux.value,
        });
        this.refundsToUpdate = this.refundsToUpdate.filter(refund => refund._id !== refundAux._id);
    }

    mergeValues() {
        this.projectsDropdown.selected.forEach((item, index) => {
            item.value = this.valuesProject[index]
        });
        this.productsDropdown.selected.forEach((item, index) => {
            item.value = this.valuesProduct[index]
        });
    }

    parcelJoinValid() {
        for(let joinParcel of this.joinParcels) {
            if(!joinParcel.name || joinParcel.parcels.length == 0)
                return false;
        }
        return true;
    }

    addJoinParcels() {
        const lastJoinParcelSerie = this.getLastJoinParcelSerie();
        const joinParcelSerie = AutoIncrement((lastJoinParcelSerie + 1), '0')
        this.joinParcels.push({ name: joinParcelSerie, parcels: [] });
    }

    getLastJoinParcelSerie() {
        const allJoinParcels = this.joinParcels.map(joinParcel => joinParcel.name);
        if(allJoinParcels.length == 0)
            return 0;

        let serieNumbers = allJoinParcels.map(joinParcel => parseInt(joinParcel.replace('FAT', '')));
        serieNumbers.sort((a, b) => a - b);

        return serieNumbers[serieNumbers.length - 1];
    }

    removeJoinParcel(index, deselectItems){
        let removeJoinParcel = true;

        for (const item of deselectItems) {
            const statusParcel = this.billingLetter.parcels[item.id].status


            if (statusParcel == 5 || statusParcel == 7) {
                removeJoinParcel = false
                return this.toastr.warning(`Uma ou mais parcelas nessa junção possui(em) status "Pago" ou "Perda Contábil"`);
            }

            this.onJoinParcelUnselect(item)
        }
        if(removeJoinParcel)
            this.joinParcels.splice(index, 1)
    }

    updateJoinParcelDropdown(addParcel: Boolean, index?: Number) {
        if(addParcel) {
            const totalParcels = this.billingLetter.parcels.length;
            this.joinParcelsDropdown.list.push({
                id: String(totalParcels - 1),
                itemName: `Parcela #${totalParcels}`
            });
            return;
        }

        let joinParcelIndexRemove, parcelIndexRemove;
        this.joinParcels = this.joinParcels.map((joinParcel, i) => {
            for(let parcelIndex in joinParcel.parcels) {
                if(Number(joinParcel.parcels[parcelIndex].id) == index) {
                    joinParcelIndexRemove = i;
                    parcelIndexRemove = parcelIndex;
                } else if(Number(joinParcel.parcels[parcelIndex].id) > index) {
                    joinParcel.parcels[parcelIndex] = {
                        id: String(Number(joinParcel.parcels[parcelIndex].id) - 1),
                        itemName: `Parcela #${joinParcel.parcels[parcelIndex].id}`
                    }
                }
            }
            return joinParcel;
        });

        if(joinParcelIndexRemove >= 0 && parcelIndexRemove >= 0)
            this.joinParcels[joinParcelIndexRemove].parcels.splice(parcelIndexRemove, 1);

        this.joinParcelsDropdown.list = [];
        this.billingLetter.parcels.forEach((parcel, parcelIndex) => {
            if(!parcel.parcelJoin)
                this.joinParcelsDropdown.list.push({
                    id: String(parcelIndex),
                    itemName: `Parcela #${parcelIndex + 1}`
                });
        });
    }

    onJoinParcelSelect(item: any, joinParcelName){
        const index = this.joinParcelsDropdown.list.findIndex(it => it.id == item.id);
        this.joinParcelsDropdown.list.splice(index, 1);
        this.billingLetter.parcels[Number(item.id)].parcelJoin = joinParcelName;
    }

    onJoinParcelUnselect(item: any){
        this.joinParcelsDropdown.list.push(item);
        this.joinParcelsDropdown.list.sort((a, b) => a.id - b.id);
        this.billingLetter.parcels[Number(item.id)].parcelJoin = '';
    }

    changeJoinParcelName(index) {
        const newJoinParcelName = this.joinParcels[index].name;
        const parcels = this.joinParcels[index].parcels;
        for(let parcel of parcels) {
            this.billingLetter.parcels[Number(parcel.id)].parcelJoin = newJoinParcelName;
        }
    }

    getIndustry(parcel){
        return parcel && parcel.company && parcel.company.industry ?
            parcel.company.industry : null
    }

    openParcelModal(index:number , obj: any) {
        this.indexParcelModal = index;
        this.objParcelModal = obj;
        this.isRecurrence = false;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }

    createNewParcel() {
        if(!(this.billingLetter.companyGroup && this.billingLetter.companyGroup._id)) {
            this.toastr.warning('É necessario adicionar um grupo de empresa');
            return
        }

        let endParcel, projects, products;

        if (this.billingLetter.parcels.length > 0) {
            endParcel = this.billingLetter.parcels[this.billingLetter.parcels.length - 1];

            projects = endParcel.project.map((project) => ({
                _id:            project._id,
                name:           project.name,
                value:          project.value,
                sapProjectId:   project.sapProjectId
            }));

            products = endParcel.product.map((product) => ({
                _id:            product._id,
                name:           product.name,
                value:          product.value,
                sapItemCode:    product.sapItemCode
            }));

            const nextMonth = Number(endParcel.competence) + 1;
            const nextYear = Number(endParcel.competenceYear);
            const monthYear = this.nextMonthYear(nextMonth, nextYear);

            endParcel = endParcel = new Parcel({
                ...endParcel,
                issueDate: moment(endParcel.issueDate).add(1, 'month'),
                dueDate: moment(endParcel.dueDate).add(1, 'month'),
                paymentDate: moment(endParcel.paymentDate).add(1, 'month'),
                nf: '',
                competence: monthYear.month,
                competenceYear: monthYear.year,
                sapDocEntry: '',
                sapDocNum: '',
                integratedSap: false,
                parcelCanceled: false,
                canEdit: true,
                project: this.projectsDropdown.selected.length > 0 ? projects : [],
                product: this.productsDropdown.selected.length > 0 ? products : [],
                parcelJoin: '',
                accountingLoss: 0,
                accountingLossJustification: '',
                isAnticipation: false
            });
            this.indexParcelModal = this.billingLetter.parcels.length;
        } else {
            projects = this.projectsDropdown.selected.map((project) => ({
                _id:            project.id,
                name:           project.itemName,
                value:          0,
                sapProjectId:   project.sapProjectId
            }));

            products = this.productsDropdown.selected.map((product) => ({
                _id:            product.id,
                name:           product.itemName,
                value:          0,
                sapItemCode:    product.sapItemCode
            }));

            endParcel = new Parcel({
                issueDate: moment(new Date()),
                dueDate: moment(new Date()).add(1, 'month'),
                nf: '',
                sapDocEntry: '',
                sapDocNum: '',
                integratedSap: false,
                parcelCanceled: false,
                canEdit: true,
                project: this.projectsDropdown.selected.length > 0 ? projects : [],
                product: this.productsDropdown.selected.length > 0 ? products : [],
                parcelJoin: '',
                isAnticipation: false
            });
            this.indexParcelModal = 0;
        }

        this.objParcelModal = endParcel
        this.isCreate = true;
        this.isRecurrence = false;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }

    closeModal(parcelCreated: boolean) {
        this.modalOpen = false;
        this.multiParcels = false;
        this.isRecurrence = false;
        this.recurrence = 1;

        if(parcelCreated) {
            this.updateJoinParcelDropdown(true);
        }
    }

    openMultipleParcelsModal(): void {
        if(!(this.billingLetter.companyGroup && this.billingLetter.companyGroup._id)) {
            this.toastr.warning('É necessario adicionar um grupo de empresa');
            return
        }

        let parcelRecurrence, projects, products;

        if (this.billingLetter.parcels.length > 0) {
            this.indexParcelModal = this.billingLetter.parcels.length;
        } else {
            this.indexParcelModal = 0;
        }

        projects = this.projectsDropdown.selected.map((project) => ({
            _id:            project.id,
            name:           project.itemName,
            value:          0,
            sapProjectId:   project.sapProjectId
        }));

        products = this.productsDropdown.selected.map((product) => ({
            _id:            product.id,
            name:           product.itemName,
            value:          0,
            sapItemCode:    product.sapItemCode
        }));

        parcelRecurrence = new Parcel({
            issueDate: moment(new Date()),
            dueDate: moment(new Date()).add(1, 'month'),
            paymentDate: moment(new Date()).add(1, 'month'),
            nf: '',
            sapDocEntry: '',
            sapDocNum: '',
            integratedSap: false,
            parcelCanceled: false,
            canEdit: true,
            project: this.projectsDropdown.selected.length > 0 ? projects : [],
            product: this.productsDropdown.selected.length > 0 ? products : [],
            refund: [],
            parcelJoin: '',
            status: 1,
            issued: false,
            type: 1,
            isAnticipation: false
        });

        this.multiParcels = true;
        this.objParcelModal = parcelRecurrence;
        this.isCreate = true;
        this.isRecurrence = true;
        this.recurrence = 1;
        this.buttonOpenModalParcel.nativeElement.click();
        this.modalOpen = true;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/billing-letter/billing-letter-create/billing-letter-create.component.ts